module.exports = __webpack_public_path__ + "media/images/front/home/parallax_m-ed7a5b60640b3673e498f4ed098f3265.png";